import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import EntityIdentifier from '@/models/Shared/EntityIdentifier';

export default class GeneralLedgerMappingOverride extends BaseInstitutionEntity {
    generalLedgerAccountMappingId: string;
    transactionType: string;
    state: string;
    debitGLAccountId: string;
    creditGLAccountId: string;
    subtransactionTypeId: string;
    createdAtUtc: Date;
    updatedAtUtc: Date;
    debitGLAccountIdentifier: EntityIdentifier;
    creditGLAccountIdentifier: EntityIdentifier;
    subtransactionTypeIdentifier: EntityIdentifier;
}